import { useEffect, useState } from "react";
import Head from "next/head";

const VodITGT = ({ content }) => {
  const [playerReady, setPlayerReady] = useState(false);
  const [playerPluginReady, setPlayerPluginReady] = useState(false);
  const descriptionURL = encodeURIComponent(content?.permaLink||process.env.NEXT_PUBLIC_WEBSITE_URL);
  var _ad_slots = {
    duration: 142,
    everyMidRole: 300,
    midLast: 60,
    preTag:
      // `https://pubads.g.doubleclick.net/gampad/ads?iu=/1007232/News_Tak_VOD_Pre_Roll&description_url=${descriptionURL}&tfcd=0&npa=0&sz=400x300%7C640x480&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&plcmt=1&vpmute=1&correlator=`,

      `https://pubads.g.doubleclick.net/gampad/ads?iu=/1007232/News_Tak_VOD_Pre_Roll&description_url=${descriptionURL}&tfcd=0&npa=0&sz=400x300%7C640x480&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&correlator=`,
    midTag: 
      // `https://pubads.g.doubleclick.net/gampad/ads?iu=/1007232/News_Tak_VOD_Mid_Roll&description_url=${descriptionURL}&tfcd=0&npa=0&sz=400x300%7C640x480&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&plcmt=1&vpmute=1&correlator=`,

      `https://pubads.g.doubleclick.net/gampad/ads?iu=/1007232/News_Tak_VOD_Mid_Roll&description_url=${descriptionURL}&tfcd=0&npa=0&sz=400x300%7C640x480&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&correlator=`,

      postTag:`https://pubads.g.doubleclick.net/gampad/ads?iu=/1007232/News_Tak_VOD_Post_Roll&description_url=${descriptionURL}&tfcd=0&npa=0&sz=400x300%7C640x480&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&correlator=`
  };

  function jWPlayerConfig(is_ad_free) {
    var _hide_ads = 0;
    let noads = "0";
    if (noads == "1") {
      _hide_ads = 1;
    }
    return {
      config_url: "",
      content_id: content?.id,
      duration: "",
      videoContainer: "nwtakPlayerVOD",
      aspectratio: "16:9",
      vtt_file: "",
      file1: content?.assetFileLink,
      file2: "",
      aps_slot: "aps_vod_at",
      title: content?.title,
      media_id: "vod_" + content?.id,
      ga_ref: "embed_video", // for embed video page for story embed video player.
      ga_ref: "video", // for inline vidoe player like lallantop.com/video/
      image: content?.headingImageUrl,
      sharing_link: content?.permaLink,
      hlslabels: {},
      source: "jwplayer",
      autostart: true,
      labelmapping: `c3="newstak", 
      ns_st_ci="${content.id}", 
      ns_st_cl="${content.durationInMs}", 
      ns_st_pu="Indiatoday Group", 
      ns_st_st="Indiatoday Group", 
      ns_st_ia="0", 
      ns_st_ge="${content.categoryName} newstak", 
      ns_st_ddt="${content.publishDate}", 
      ns_st_ce="1", 
      ns_st_tdt="${content.publishDate}", 
      ns_st_title="${content.title}", 
      ns_st_ep="${content.title}", 
      ns_st_pr="${content.title}"
    `.replace(/\s+/g, " "),
      publisherId: "8549097",
      advertising: {
        client: "googima",
        skipoffset: 30,
        midRollSchedule: _ad_slots,
      },
      noads: _hide_ads,
      ga: {},
      sharing_sites: ["facebook", "twitter", "email"],
      plugins: {
        "https://akm-img-a-in.tosshub.com/aajtak/resource/smedia2/lightsout.js":
          {},
      },
      repeat: false,
    };
  }

  useEffect(() => {
    addPlayerScripts();
  }, []);

  useEffect(() => {
    try {
      if (playerReady) {
        if (
          typeof window !== "undefined" &&
          window.document &&
          window.document.createElement
        ) {
          if (window.playerState == "PLAYING") {
            window.mediaPlayer.pause();
            window.playerState = "PAUSE";
          }
          runPlayer();
        } else {
          runPlayer();
        }
      }
    } catch (error) {
      console.log("Ad refresh error", error);
    }
  }, [playerReady, playerPluginReady]);

  const runPlayer = () => {
    try {
      let playerDiv = document.getElementById("nwtakPlayerVOD");
      console.log("..VOD pleayer 4>>>>>");
      if (playerDiv) {
        console.log("..VOD pleayer 5>>>>>");
        playerDiv.innerHTML = "";
        if (typeof ITGDPlayer !== "undefined") {
          new ITGDPlayer(window.jwConfig, "nwtakPlayerVOD");
        }
        window.playerState = "PLAYING";
      }
    } catch (error) {
      console.log("..VOD pleayer 9>>>>>");
      console.log("Aderror", error);
    }
  };

  const addPlayerScripts = () => {
    console.log("..VOD pleayer 2>>>>>");
    if (typeof window !== "undefined") {
      let jwConfig = jWPlayerConfig(true);
      window.jwConfig = jwConfig;
      let script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://akm-img-a-in.tosshub.com/sites/player/media/vod-3-0/vod-alpha.js?v=25112021-07";
      script.id = "playerVidJs";
      script.onload = () => {
        console.log("✅ External script loaded");
        setPlayerReady(true);
      };
      document.head.append(script);

      let script2 = document.createElement("script");
      script2.type = "text/javascript";
      script2.src =
        "https://census-web.scorecardresearch.com/plugins/streaming-jwplayer/v2/current.js";
      script2.id = "pluginVidJs";
      script2.onload = function () {
        setPlayerPluginReady(true);
      };
      document.head.append(script2);
    }
  };
  return (
    <>
      <Head>
        <link
          href="https://akm-img-a-in.tosshub.com/sites/player/media/vod-3-0/vod-alpha.css?v=25112021-02"
          as="style"
          rel="stylesheet"
        />
      </Head>

      <div
        id="nwtakPlayerVOD"
        suppressHydrationWarning
        style={{
          display: "block",
          position: "relative",
          margin: "1rem auto",
          width: "100%",
          height: "auto",
          backgroundColor: "black",
        }}
      >
       
      </div>
    </>
  );
};
export default VodITGT;
